<template>
  <header>
    <div class="home_hero">
      <h2>Marché Human Way</h2>
      <p>La façon humaine de faire les choses!</p>
    </div>
  </header>

  <div class="info">
    <h1>Bienvenue dans la section technologique de Human Way</h1>
    <p>
      L'intelligence artificielle peut offrir de nombreux avantages pour la
      santé et l'alimentation. Grâce à l'IA, il est désormais possible pour tout
      le monde d'accéder à des conseils personnalisés sur la santé et
      l'alimentation, notamment pour les personnes ayant des restrictions
      alimentaires. Les applications et les sites Web peuvent aider à la
      planification de menus et à la recherche d'ingrédients adaptés. Human Way
      souhaite rendre cette technologie accessible à tous, pour créer un avenir
      plus sain et plus durable pour tous.
    </p>
  </div>
  <div class="intro">
    <img class="robot" src="../assets/img/Robot.png" />
  </div>
  <div class="info">
    <p>
      Je te présente le petit robot de Human Way : Tousky. Tu peux lui poser
      toute sorte de questions, mais voici quelques exemples de questions pour
      t’aider à débuter :
    </p>
    <p>• Peux-tu me donner des idées de repas pour ce soir?</p>
    <p>
      • Peux-tu me donner des idées de repas avec du poulet, de la salade et des
      poivrons?
    </p>
    <p>
      • Est-ce qu’il y a vraiment des avantages à la viande nourrie à l’herbe?
    </p>

    <p>Alors maintenant, à toi d’essayer!</p>
  </div>
  <div class="home">
    <OpenAiAPI />
  </div>
</template>

<script>
// @ is an alias to /src
import OpenAiAPI from "@/components/openai-api.vue";

export default {
  name: "HomeView",
  components: {
    OpenAiAPI
  }
};
</script>

<style>
.home_hero {
  padding: 8em 0 13em 0;
  /* margin-bottom: 5em; */
  background-image: url("../assets/img/IA.png");
  background-position: center 70%;
  background-size: cover;
  line-height: 1.75;
  text-align: center;
}

.home_hero h2,
.home_hero p {
  color: #fff;
}

.info {
  text-align: center;
  margin: 0 5rem;
}
.info h1,
.info p {
  color: #fff;
}

.intro {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 5rem;
}

.robot {
  max-width: 50%;
}

@media screen and (max-width: 768px) {
  .intro {
    margin: 1rem;
  }

  .robot {
    max-width: 100%;
  }

  .info {
    text-align: center;
    margin: 0 1rem;
  }

  .home_hero {
    padding: 5em 0 5em 0;
  }
}
</style>
